import { MantineProvider, type MantineThemeOverride, type Tuple } from '@mantine/core';
import type { ReactNode } from 'react';

declare module '@mantine/core' {
  export interface MantineThemeColorsOverride {
    colors: { bagel: Tuple<string, 10> };
  }
}

// Brand color used across the dashboard (kept in sync with bagel-dashboard/src/constants/colors.ts)
export const PRIMARY_BLUE = '#5C5CEB';
export const PRIMARY_OPACITY_90 = 'rgba(92, 92, 235, 0.9)';
export const PRIMARY_OPACITY_80 = 'rgba(92, 92, 235, 0.8)';
export const PRIMARY_OPACITY_40 = 'rgba(92, 92, 235, 0.4)';
export const PRIMARY_OPACITY_20 = 'rgba(92, 92, 235, 0.2)';
export const PRIMARY_OPACITY_12 = 'rgba(92, 92, 235, 0.12)';
export const PRIMARY_OPACITY_05 = 'rgba(92, 92, 235, 0.05)';
export const LIGHT_BLUE_BACKGROUND = 'rgba(92, 92, 235, 0.1)';
export const LIGHT_BLUE_CELL = 'rgba(217, 218, 247, 1)';
export const LIGHT_BLUE_BACKGROUND_AI = 'rgba(239, 239, 253, 1)';
export const MAIN_DARK_PRIMARY = '#212529';
export const LIGHT_GREY_BG = '#F8F9FA';
export const DARK_GREY_TEXT = '#585c68';
export const LIGHT_PURPULE_BACKGROUND = '#F8F8FB';
export const SEGMENT_TEXT = 'rgba(88, 92, 104, 1)';
export const DEFAULT_PRIORITY_COLOR = '#2684FF';
export const DEFAULT_PRIORITY_BACKGROUND_COLOR = '#F7FAFF';

// 10-shade Mantine palette around the brand color (#5C5CEB lives at shade 5)
const bagelPalette: Tuple<string, 10> = [
  '#EFEFFE',
  '#D8D9FA',
  '#B7B8F3',
  '#9596ED',
  '#7676E8',
  '#5C5CEB',
  '#4848D6',
  '#3535BD',
  '#28289F',
  '#1F1F82',
];

export const bagelTheme: MantineThemeOverride = {
  fontFamily: 'Inter',
  primaryColor: 'bagel',
  colors: {
    bagel: bagelPalette,
  },
};

interface BagelMantineProviderProps {
  children: ReactNode;
}

export function BagelMantineProvider({ children }: BagelMantineProviderProps) {
  return (
    <MantineProvider withGlobalStyles withNormalizeCSS theme={bagelTheme}>
      {children}
    </MantineProvider>
  );
}
